import { Box, MenuItem, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import { API } from "../../../api/API";

import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import ListItemText from "@mui/material/ListItemText";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";

const ModifiPolice = ({ show, handleClose, onRefresh, police }) => {
  const [modules, setModules] = useState([]);
  const [selectedModules, setSelectedModules] = useState([]);

  // Schéma de validation pour les champs de la police
  const policeSchema = object({
    label: string().required("Le label est requis"),
    description: string().required("La description est requise"),
  });

  const fetchModules = async () => {
    try {
      const response = await API.get("/modules");
      const { data } = response.data;
      setModules(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des modules:", error);
      toast.error("Impossible de récupérer les modules");
    }
  };
  const getPoplice = async () => {
    try {
      let policeId = police.id;
      if (!policeId) {
        console.error("Aucune police sélectionnée");
        return;
      }
      const response = await API.get(`/polices/${policeId}/details`);
      const { police: policeData } = response.data;
      if (policeData && policeData.module_police) {
        let ids = policeData.module_police.map((module) => module.id);
        setSelectedModules(ids);
      }

      //setSelectedModules(policeData.modules);
    } catch (error) {
      console.error("Erreur lors de la récupération de la police:", error);
      toast.error("Impossible de récupérer la police");
    }
  };
  useEffect(() => {
    fetchModules();
    getPoplice();
  }, [police]);

  //si policeId est null, on fait un return
  if (!police) {
    return null;
  }
  let policeId = police.id;
  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        className=""
      >
        <Modal.Header closeButton className="bg-success text-light">
          <Modal.Title id="contained-modal-title-vcenter">
            <Typography variant="h6" component="h2" color="inherit">
              Modification de la police
            </Typography>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Box sx={{ maxHeight: "70vh", overflowY: "auto", padding: "0 16px" }}>
            {police && (
              <Formik
                validationSchema={policeSchema}
                initialValues={{
                  label: police.label || "",
                  description: police.description || "",
                }}
                onSubmit={async (values, { setSubmitting, resetForm }) => {
                  const toastId = toast.loading("Mise à jour en cours...");
                  try {
                    const _values = { ...values, modules: selectedModules };
                    await API.put(`/polices/${policeId}`, _values);
                    toast.update(toastId, {
                      render: "Police mise à jour avec succès!",
                      type: "success",
                      isLoading: false,
                      autoClose: 5000,
                    });
                    onRefresh();
                    resetForm();
                    handleClose();
                  } catch (error) {
                    let errorMessage =
                      "Erreur lors de la mise à jour de la police";

                    if (error.response) {
                      errorMessage =
                        error.response.data.message ||
                        `${error.response.status}: ${JSON.stringify(
                          error.response.data.error
                        )}`;
                    } else if (error.request) {
                      errorMessage = "Pas de réponse du serveur";
                    }

                    toast.update(toastId, {
                      render: errorMessage,
                      type: "error",
                      isLoading: false,
                      autoClose: 5000,
                    });
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group as={Col} md={12} className="mb-3">
                        <Form.Label>
                          Label <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                          name="label"
                          type="text"
                          placeholder="Label de la police"
                          value={values.label}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.label && !!errors.label}
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.label}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    <Row className="mb-3">
                      <Form.Group as={Col} md={12} className="mb-3">
                        <Form.Label>
                          Description <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          name="description"
                          placeholder="Description de la police"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.description && !!errors.description
                          }
                          className="rounded-input"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.description}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group as={Col} md={12} className="mb-3">
                        <Form.Label>
                          Modules <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Select
                          labelId="modules-select-label"
                          id="modules-select"
                          multiple
                          value={selectedModules}
                          onChange={(event) => {
                            const value = event.target.value;
                            setSelectedModules(value);
                            setFieldValue("modules", value);
                          }}
                          input={<OutlinedInput />}
                          renderValue={(selected) => (
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 0.5,
                              }}
                            >
                              {selected.map((id) => (
                                <Chip
                                  key={id}
                                  label={
                                    modules.find((module) => module.id === id)
                                      ?.label
                                  }
                                />
                              ))}
                            </Box>
                          )}
                          sx={{
                            borderRadius: "8px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1976d2",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#115293",
                            },
                          }}
                        >
                          {modules.map((module) => (
                            <MenuItem key={module.id} value={module.id}>
                              <Checkbox
                                checked={selectedModules.includes(module.id)}
                              />
                              <ListItemText
                                primary={`${module.label}-${module.description}`}
                              />
                            </MenuItem>
                          ))}
                        </Select>
                        {touched.modules && errors.modules && (
                          <Typography
                            variant="body2"
                            color="error"
                            sx={{ mt: 1 }}
                          >
                            {errors.modules}
                          </Typography>
                        )}
                      </Form.Group>
                    </Row>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 2,
                        mt: 3,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={handleClose}
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          padding: "6px 16px",
                        }}
                      >
                        Annuler
                      </Button>

                      <Button
                        type="submit"
                        variant="contained"
                        color="success"
                        disabled={isSubmitting}
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          padding: "6px 24px",

                          "&:hover": { backgroundColor: "#115293" },
                        }}
                      >
                        {isSubmitting ? "Mise à jour..." : "Mettre à jour"}
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            )}
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModifiPolice;
